import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { icons } from '../../../constants/images'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useCallback, useEffect, useState } from 'react';
import DashboardApi from '../../../api/dashboard/dashboard.api';
import saveAs from 'file-saver';
type Props = {
    idDepartment?: number
    idFiscalYear?: string
    keywordLevel1?: string
    keywordLevel2?: string
    keywordLevel3?: string
    keywordLevel4?: string
    endDate?: string;
    startDate?: string;
}
export default function Dashboard2(props: Props) {
    const { idDepartment, idFiscalYear, keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4, endDate, startDate } = props
    const [data, setData] = useState<any>([])
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenu = Boolean(anchorEl);
    const handleClickMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const loadData = useCallback(async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear === 'all' ? '' : idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (startDate) condition = { ...condition, startDate: startDate };
        if (endDate) condition = { ...condition, endDate: endDate };

        DashboardApi.getDashboardSummaryByDepartment(condition).then((res) => {
            if (res?.data?.success) {
                const data = res.data.result;
                setData(data);
            }
        });
    }, [idDepartment, idFiscalYear, keywordLevel1, keywordLevel2, keywordLevel3, keywordLevel4, endDate, startDate]);

    useEffect(() => {
        loadData()
    }, [loadData])
    const download = async () => {
        let condition: any = {};
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment };
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear === 'all' ? '' : idFiscalYear };
        if (keywordLevel1) condition = { ...condition, keywordLevel1: keywordLevel1 };
        if (keywordLevel2) condition = { ...condition, keywordLevel2: keywordLevel2 };
        if (keywordLevel3) condition = { ...condition, keywordLevel3: keywordLevel3 };
        if (keywordLevel4) condition = { ...condition, keywordLevel4: keywordLevel4 };
        if (startDate) condition = { ...condition, startDate: startDate };
        if (endDate) condition = { ...condition, endDate: endDate };
        DashboardApi.getDashboardSummaryByDepartmentDownload(condition).then((res) => {
            const data = res.data;
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'รายงานแยกตามหน่วยงาน');
        }
        );
    }
    const options = {
        chart: {
            type: 'bar',
            // scrollablePlotArea: {
            //     minWidth: 2000,
            //     scrollPositionX: 1
            // }
            zoomType: 'x'
        },
        title: {
            text: null
        },

        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        xAxis: {
            type: 'category',
            title: {
                text: 'หน่วยงาน'
            },
            labels: {
                rotation: -45,
                style: {
                    fontSize: '13px',
                    fontFamily: 'Verdana, sans-serif'
                }
            }
        },
        yAxis: {
            min: 0,
            title: null
            // labels: {
            //     formatter: function () {
            //         return this.value.toLocaleString();
            //     },
            // }

        },
        legend: {
            enabled: false
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                color: '#90BE6D'


            },
            series: {
                borderRadiusTopLeft: 8,
                borderRadiusTopRight: 8,
                color: '#90BE6D'
            }
        },
        tooltip: {
            pointFormatter: function (this: any) {
                var point = this
                return `ขนาดรวม: <b>${(point.sumFileSize / 1000000)?.toFixed(2)?.toLocaleString()} MB</b><br/>จำนวน: ${point.y?.toLocaleString()} ไฟล์`
            },
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        series: data?.map((x: any) => {
            return {
                name: x?.departmentName,
                data: [{
                    name: x?.departmentName,
                    y: +x?.fileCount,
                    sumFileSize: +x?.sumFileSize
                }],
                type: 'column',
            }
        })
    };
    return (
        <Box sx={{
            borderRadius: 'var(--Main-System-8px, 8px)',
            border: '1px solid var(--Background-Light-Disabled, #E5E5E7)',
            background: '#FFF',
            boxShadow: '0px 4px 6px - 1px rgba(16, 24, 40, 0.10), 0px 2px 4px - 2px rgba(16, 24, 40, 0.10)',
        }}>
            <div style={{
                padding: '16px 20px', borderBottom: '1px solid var(--Stroke-Light-Base, #E5E5E7)',
                display: "flex", justifyContent: 'space-between'
            }}>
                <Typography>แยกตามหน่วยงาน</Typography>
                <IconButton
                    aria-label="more"
                    id="long-button"
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClickMenu}
                >
                    <icons.dotMenu />

                </IconButton>
            </div>
            <HighchartsReact highcharts={Highcharts} options={options} />
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={openMenu}
                onClose={handleCloseMenu}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >

                <MenuItem onClick={() => { download() }}>
                    ดาวน์โหลด
                </MenuItem>
            </Menu>
        </Box >
    )
}
